<script setup>
import { computed } from 'vue'
import team1 from '@/assets/img/team/doni_lesmana.jpg'
import team2 from '@/assets/img/team/idris.jpg'
import team3 from '@/assets/img/team/tio.jpg'

const props = defineProps({
    teams: {
        type: Array,
        default: () => []
    }
})

// Fallback teams when no API data
const fallbackTeams = [
    { img: team1, name: 'Doni Lesmana', job: 'Creative Director', linkedinUrl: '#' },
    { img: team2, name: 'Idris', job: 'Creative Director', linkedinUrl: '#' },
    { img: team3, name: 'Tio', job: 'Creative Director', linkedinUrl: '#' }
]

// Use API teams if available, otherwise use fallback
const displayTeams = computed(() => {
    if (props.teams.length > 0) {
        return props.teams.map(team => ({
            img: team.photo,
            name: team.name,
            job: team.title || team.job,
            linkedinUrl: team.linkedinUrl || '#'
        }))
    }
    return fallbackTeams
})
</script>

<template>
    <section class="wrapper bg-black">
        <div class="container pt-10 pb-12 pt-md-14 pb-md-16 text-center">
            <div class="row">
                <div class="mx-auto text-white">
                    <h1 class="display-1 mb-3 text-white">
                        Meet <span style="color: #ffae0b;">Our Team</span>
                    </h1>

                    <p class="lead">
                        Behind every great project is a team of passionate individuals dedicated to bringing ideas to
                        life. Meet the creative minds and talented professionals who make it all happen at
                        SmilePictures.
                    </p>

                    <!-- TEAM CARDS -->
                    <div class="row g-4 mt-8 justify-content-center">
                        <div class="col-12 col-md-6 col-lg-3" v-for="(item, i) in displayTeams" :key="i">
                            <div class="team-card">
                                <div class="team-image">
                                    <img :src="item.img" :alt="item.name" />
                                </div>

                                <div class="team-info">
                                    <div class="team-content">
                                        <span class="team-name">{{ item.name }}</span>
                                        <span class="team-role">{{ item.job }}</span>

                                        <a :href="item.linkedinUrl" target="_blank" rel="noopener" class="linkedin-icon"
                                            aria-label="LinkedIn">
                                            <i class="uil uil-linkedin"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /TEAM CARDS -->

                </div>
            </div>
        </div>
    </section>
</template>

<style>
.team-card {
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    background: #000;
}

/* FORCE 1:1 IMAGE */
.team-image {
    aspect-ratio: 3 / 4;
    overflow: hidden;
}

.team-image img {
    width: 100%;
    height: 100%;
    /* ⬅️ INI YANG KURANG */
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
}

/* Gradient bottom */
.team-info {
    position: absolute;
    inset: 0;
    padding: 20px;

    display: flex;
    align-items: flex-end;
    justify-content: center;

    background: linear-gradient(180deg,
            rgba(130, 3, 88, 0) 51%,
            rgba(63, 1, 48, 1) 100%);
}

/* content wrapper */
.team-content {
    text-align: center;
    transform: translateY(84px);
    transition: transform 0.35s ease;
}

/* name always visible */
.team-name {
    display: block;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
}

/* role & linkedin hidden initially */
.team-role,
.linkedin-icon {
    display: block;
    margin-top: 6px;
    color: #fff;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
}

.linkedin-icon {
    font-size: 1.3rem;
    margin-top: 10px;
    text-decoration: none;
}

/* hover reveal */
.team-card:hover .team-content {
    transform: translateY(0);
}

.team-card:hover .team-role,
.team-card:hover .linkedin-icon {
    opacity: 1;
    transform: translateY(0);
}

/* image hover zoom */
.team-image img {
    transition: transform 0.4s ease;
}

.team-card:hover img {
    transform: scale(1.05);
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .row.g-4>.col-md-6 {
        flex: 0 0 33.3333%;
        max-width: 33.3333%;
    }
}
</style>
